export default "__VITE_ASSET__a232519f__"